import React from "react";
import "./reelsComponent.scss";

const ReelsComponent = () => {
  const reels = [
    { id: 1, videoUrl: "/anupvideo4.mp4", title: "Reel 1" },
    { id: 2, videoUrl: "/anupvideo2.mp4", title: "Reel 2" },
    { id: 3, videoUrl: "/anupvideo3.mp4", title: "Reel 3" },
  ];

  return (
    <div className="reels-container-wrapper">
      <h2 className="heading">How We Are Different?</h2>
      <div className="reels-container">
        {reels.map((reel) => (
          <div key={reel.id} className="reel-card">
            <video
              src={reel.videoUrl}
              controls
              className="reel-video"
              title={reel.title}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReelsComponent;
